import { DefaultLayout } from "../../components/DefaultLayout/DefaultLayout";
import { useNavigate } from "react-router-dom";
import "./AboutPage.css";
import PersonCard from "../../components/Cards/PersonCard";
import GeorgeHeadshot from "../../assets/georgeHeadshotSquare.png";
import TylerHeadshot from "../../assets/tylerHeadshotSquare.png";
import KyraHeadshot from "../../assets/kyraHeadshotSquare.png";
import { Box, Button, Center, SimpleGrid, Space, Stack, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import TwoContractorsWalking from '../../assets/two-contractors-walking.png';

export const AboutPage = () : JSX.Element => {

    const navigate = useNavigate();

    return (
        <DefaultLayout showNavBar={true} showSearchBar={true} showFooter={true}>
            <div className="about-hero-bleed">
                <div className="about-hero-container">
                    <Box pt={'6em'} pb={'6em'} pl={'1em'} pr={'1em'}>
                        <Center>
                            <Text ta={'center'} c="#1F2937" fw={'bold'} visibleFrom="md" fz={44}>About Method Materials</Text>
                            <Text ta={'center'} c="#1F2937" fw={'bold'} hiddenFrom="md" fz={30}>About Method Materials</Text>
                        </Center>
                        <Center>
                            <Text ta={'center'} c={'#4B5563'}>Building a complete ecosystem to help contractors grow more profitable businesses</Text>
                        </Center>
                    </Box>
                </div>
            </div>
            {/* Mission Section */}
            <Box>
                <SimpleGrid cols={{ base: 1, md: 2 }} p={'10%'} style={{ alignItems: 'center' }}>
                    <Box mb={'4em'}>
                        <Stack justify="center">
                            <Text fz={24} c="#1F2937" fw={'bold'}>Our Mission</Text>
                            <Text fz={20} c={'#4b5563'}>
                                At Method Materials, our mission is to help contractors operate more efficiently and build more profitable businesses. Through collective buying power, strategic supplier relationships, discounted professional services, and a collaborative contractor network, we provide the tools and resources construction companies need to reduce costs, create new opportunities, and scale with confidence.
                            </Text>
                        </Stack>
                    </Box>
                    <Center>
                        <Box>
                            <Center>
                                <img style={{borderRadius: '1em', width: '90%', height: '90%'}} src={TwoContractorsWalking}/>
                            </Center>
                        </Box>
                    </Center>
                </SimpleGrid>
            </Box>
            {/* What is a GPO Section */}
            <Box style={{backgroundColor: '#303030'}}>
                <Space h={'2em'} />
                <Center>
                    <Stack>
                        <Text c={'white'} fz={24} fw={'bold'} ta={'center'}>What is a GPO?</Text>
                        <Text c={'white'} fz={20} pl={'5%'} pr={'5%'} ta={'center'}>A GPO (Group Purchasing Organization) combines the buying power of multiple contractors to secure better pricing from suppliers. At Method Materials, we help contractors save money on materials while also providing access to valuable business resources and partnerships.</Text>
                    </Stack>
                </Center>
                <Space h={'2em'} />
            </Box>
            {/* Founders Section - full-bleed band */}
            <div className="about-founders-bleed">
                <div className="about-hero-container">
                    <div className="about-founders-container">
                        <Center>
                            <Text c="#1F2937" fz={30} fw={'bold'}>Our Founders</Text>
                        </Center>
                        <div className="about-founders-cards">
                    <PersonCard
                        image={GeorgeHeadshot}
                        name="George Ringer"
                        role="Founder, CEO"
                        description="Construction industry veteran with 15 years of experience as a residential home builder, building partnerships, and helping contractors grow more profitable businesses."
                    />

                    <PersonCard
                        image={TylerHeadshot}
                        name="Tyler Valkavich"
                        role="Founder, CTO"
                        description="Leads technology and innovation initiatives that streamline operations, improve efficiency, and help members maximize profitability."
                    />

                    <PersonCard
                        image={KyraHeadshot}
                        name="Kyra Dorn"
                        role="Founder, CFO"
                        description="Leads financial strategy and growth initiatives focused on helping members reduce costs, improve profitability, and create long-term business success.
"
                    />
                </div>
                    </div>
                </div>
            </div>
            {/* Frame Card Section */}
            <Center pt={'6em'} pb={'6em'}>
                <Box className="hover-shadow"  maw={'90%'} p={'4em'} style={{backgroundColor: '#f7f9fa', borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)'}}>
                    <Stack align="center">
                        <Text ta={'center'} c="#1F2937" fz={30} fw={'bold'}>Build a More Profitable Business</Text>
                        <Text ta={'center'} w={'90%'}>Join a growing network of contractors leveraging stronger buying power, strategic partnerships, and valuable business resources to reduce costs, increase efficiency, and scale smarter.</Text>
                        <Button color={'#cc7800'} rightSection={<IconArrowRight />} onClick={() => navigate('/', { state: { scrollToTop: true } })}>Join For Free</Button>
                    </Stack>
                </Box>
            </Center>
        </DefaultLayout>
    );
}
